import { Grid, LabelValue, Typography } from "../../basics"
import { InvestorProfileChip } from "../InvestorProfileChip"
import { IClientCardProps } from "./types"
import { StyledClientCard } from "./styled"
import intl from "src/internationalization/intl"

const ClientCard = (props: IClientCardProps) => {
    return (
        <StyledClientCard>
            <Grid container justifyContent="space-between" alignItems="center" gap={1} wrap="nowrap">
                <Grid item sx={{ minWidth: 0 }}>
                    <Typography variant="body1" noWrap>
                        {props.clientName}
                    </Typography>
                    <InvestorProfileChip profile={props.clientInvestProfile} />
                </Grid>
                <Grid item sx={{ flexShrink: 0 }}>
                    <LabelValue
                        label={intl("opportunityVolumeLabel")}
                        value={props.opportunityVolume}
                        align="right"
                    />
                </Grid>
            </Grid>
        </StyledClientCard>
    )
}

export { ClientCard }
